import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/HeroNew';
import Services from './components/Services';
import Works from './components/Works';
import Stats from './components/Stats';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Testimonials from './components/Testimonials';
import Partners from './components/Partners';
import Videos from './components/Videos';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProjectDetails from './components/ProjectDetails';

function HomePage() {
    const location = useLocation();

    React.useEffect(() => {
        // Scroll to section from navigation state
        const stateSection = location.state && location.state.scrollTo;
        const hash = location.hash && location.hash.replace('#', '');
        const target = stateSection || hash;

        if (target) {
            // Wait a tick to ensure elements are rendered
            setTimeout(() => {
                const el = document.getElementById(target);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
                // Clear history state to prevent repeated scrolling on back/forward
                window.history.replaceState({}, document.title);
            }, 50);
        }
    }, [location]);

    return (
        <>
            <Navbar />
            <Hero />
            <Services />
            <Works />
            <Stats />
            <Experience />
            <Projects />
            <Testimonials />
            <Partners />
            <Videos />
            <Contact />
            <Footer />
        </>
    );
}

function ProjectPage() {
    return (
        <>
            <Navbar />
            <ProjectDetails />
            <Footer />
        </>
    );
}

function AppContent() {
    const { isRTL } = useLanguage();

    return (
        <div className={`App ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/project/:id" element={<ProjectPage />} />
            </Routes>

            <a
                href="https://wa.me/+201004449782"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-float"
                title="WhatsApp"
            >
                <i className="fa fa-whatsapp"></i>
            </a>
        </div>
    );
}

function App() {
    return (
        <Router>
            <LanguageProvider>
                <AppContent />
            </LanguageProvider>
        </Router>
    );
}

export default App;
